import { render, staticRenderFns } from "./ShShopCartIcon.vue?vue&type=template&id=0d79610c&scoped=true&"
import script from "./ShShopCartIcon.vue?vue&type=script&lang=js&"
export * from "./ShShopCartIcon.vue?vue&type=script&lang=js&"
import style0 from "./ShShopCartIcon.vue?vue&type=style&index=0&id=0d79610c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d79610c",
  null
  
)

export default component.exports